module.exports = __webpack_public_path__ + "static/media/asain_doct.7f4043b9.jpg";